/**
 * Worker selection strategies (internal)
 */

/**
 * Random worker selection
 * @param {import('./types.js').WorkerInstance[]} workers
 * @returns {import('./types.js').WorkerInstance}
 */
function randomSelector(workers) {
  const index = Math.floor(Math.random() * workers.length)
  return workers[index]
}

/**
 * First worker selection
 * @param {import('./types.js').WorkerInstance[]} workers
 * @returns {import('./types.js').WorkerInstance}
 */
function firstSelector(workers) {
  return workers[0]
}

/**
 * Create round-robin selector with state
 * @returns {import('./types.js').SelectorFunction}
 */
function createRoundRobinSelector() {
  const counters = new Map()

  return function roundRobinSelector(workers, workerName) {
    const count = counters.get(workerName) || 0
    const index = count % workers.length
    counters.set(workerName, count + 1)
    return workers[index]
  }
}

/**
 * Get selector function from config
 * @param {import('./types.js').SelectorStrategy|import('./types.js').SelectorFunction} [selector='random']
 * @returns {import('./types.js').SelectorFunction}
 */
export function getSelector(selector = 'random') {
  if (typeof selector === 'function') {
    return selector
  }

  switch (selector) {
    case 'first':
      return firstSelector
    case 'round-robin':
      return createRoundRobinSelector()
    case 'random':
    default:
      return randomSelector
  }
}
